import { lazy, Suspense } from "react";
import type { Options } from "react-markdown";

/**
 * Lazily-loaded markdown renderer.
 *
 * `react-markdown` (plus its micromark/mdast dependency tree, ~hundreds of KB)
 * was being hoisted into the shared entry chunk because several always-reachable
 * components imported it statically. Wrapping it in `React.lazy` turns it into a
 * dynamic-import chunk that only downloads when markdown is actually rendered
 * (blog posts, chat messages, AI replies, call summaries) — keeping it off the
 * landing/marketing critical path.
 *
 * The `import type { Options }` above is erased at build time, so it does NOT
 * pull react-markdown into any bundle.
 */
const ReactMarkdown = lazy(() => import("react-markdown"));

export default function LazyMarkdown(props: Options) {
  return (
    <Suspense fallback={null}>
      <ReactMarkdown {...props} />
    </Suspense>
  );
}
